export default __webpack_public_path__ + "static/media/aboutJs3.4a51a938.jpg";